
import { Options, Vue } from 'vue-class-component'
import { PropSync } from 'vue-property-decorator'
@Options({
  emits: ['update:isMultipleScan'],
  name: 'BulkScanSwitchButton',
})
export default class BulkScanSwitchButton extends Vue {
  @PropSync('isMultipleScan', { type: Boolean, default: true }) _isMultipleScan!: boolean

  handleSwitchChange(value: boolean) {
    this.$emit('update:isMultipleScan', value)
  }
}
